import { j as e } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as A, useState as S, useRef as b, useMemo as z, useCallback as B, cloneElement as ue, useEffect as N } from "react";
import { c as r } from "./tw-cn-mXgPecoF.mjs";
import { R as O } from "./rectangle-button-Oc2I1olX.mjs";
import { I as me } from "./ic_close-BJ5TqFBV.mjs";
import { t as fe } from "./throttle-CbOTDqvg.mjs";
import { o as pe } from "./index-CcECYkhV.mjs";
import { I as ye } from "./icon-button-DImUgRzQ.mjs";
import { c as d } from "./index-BpNK5r1N.mjs";
import { u as P } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { createPortal as he } from "react-dom";
const ge = d(["w-screen h-screen fixed left-0 top-0 bg-scrim"], {
  variants: {
    show: {
      true: "animate-dimFadeIn",
      false: "animate-dimFadeOut"
    }
  }
}), G = A(
  ({ show: l = !0, zMax: o, onClick: s = () => {
  }, onAnimationEnd: i = () => {
  }, children: n }, t) => {
    const [f, p] = S(!1), y = ge({
      show: l
    });
    return P(() => {
      p(!1);
    }, [l]), !l && f ? null : (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- dim layer click
      /* @__PURE__ */ e.jsx(
        "div",
        {
          className: r(y, o ? "z-max" : ""),
          onAnimationEnd: () => {
            p(!0), i();
          },
          onClick: s,
          ref: t,
          children: n
        }
      )
    );
  }
);
G.displayName = "NDS.DimLayer";
const xe = ({ show: l, mode: o }) => {
  P(() => {
    if (!l) return;
    window.ya__ || (window.ya__ = { dialogCount: 0 });
    const s = window.ya__.dialogCount ?? 0;
    if (window.ya__.dialogCount = s + 1, o === "fixed") {
      const [i, n, t] = [document.body.style.position, window.scrollY, window.scrollX];
      return document.body.style.position = "fixed", document.body.style.top = `-${n}px`, document.body.style.left = `-${t}px`, () => {
        window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.position = i, window.scroll({ top: n, left: t }));
      };
    }
    return document.body.style.overflow = "hidden", () => {
      window.ya__ || (window.ya__ = { dialogCount: 0 }), window.ya__.dialogCount--, window.ya__.dialogCount <= 0 && (document.body.style.overflow = "unset");
    };
  }, [o, l]);
}, $ = "_ROOT_NDS_MODAL_", Ce = ({ id: l, children: o, show: s, zIndex: i = 1 }) => {
  const n = b(null), [t, f] = S(null), p = z(() => t ? he(o, t) : null, [o, t]), y = B(() => {
    var a;
    (a = t == null ? void 0 : t.parentElement) == null || a.removeChild(t);
  }, [t]), g = B(() => {
    n.current = document.getElementById($), n.current || (n.current = document.createElement("div"), n.current.id = $, n.current.style.position = "relative", n.current.style.zIndex = `${i}`, n.current.className = "tw", document.body.appendChild(n.current));
    const a = `modal-${l}`;
    let c = document.getElementById(a);
    return c || (c = document.createElement("div"), c.id = a, n.current.appendChild(c)), c;
  }, [l]);
  return P(() => {
    if (!s) return;
    const a = g(), c = document.createElement("div");
    return f(c), a.appendChild(c), () => {
      c.addEventListener("animationend", () => {
        var x, C;
        (x = c.parentElement) == null || x.removeChild(c), (C = a.parentElement) == null || C.removeChild(a);
      });
    };
  }, [s, g]), {
    portal: p,
    modalElement: t,
    clearModalElement: y
  };
}, F = (l) => {
  const { id: o = Date.now().toString(), mode: s = "overflow", show: i = !0, zIndex: n, children: t } = l;
  xe({ show: i, mode: s });
  const f = t ? ue(t, {
    id: o,
    mode: s
  }) : /* @__PURE__ */ e.jsx(e.Fragment, {}), { portal: p, clearModalElement: y } = Ce({
    id: o,
    show: i,
    zIndex: n,
    children: /* @__PURE__ */ e.jsx(
      G,
      {
        id: o,
        mode: s,
        onAnimationEnd: () => {
          !i && y();
        },
        onClick: l.onBackdropClick,
        show: i,
        children: f
      }
    )
  });
  return p;
};
F.displayName = "NDS.Modal";
const W = d([
  "fixed mx-auto left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-h-screen min-h-88"
]), ve = d(
  ["inline-flex flex-col align-center justify-center bg-static-white rounded-12 p-16 pt-32 w-[29.6rem]"],
  {
    variants: {
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      }
    }
  }
), we = d(["inline-flex flex-col items-center justify-center"]), Se = d([
  "typography-subtitle-16-bold text-text-neutral-main select-none text-center whitespace-pre-line"
]), be = d(["inline-flex flex-col items-center justify-center "]), _e = d([
  "mt-12 typography-body-14-regular text-text-neutral-sub select-none text-center whitespace-pre-line"
]), je = d([
  "inline-flex typography-body-14-bold flex-row items-center justify-center gap-8 mt-24"
]), Ne = A(
  ({ id: l, show: o, title: s, description: i, positiveButton: n, negativeButton: t, zIndex: f, onAnimationEnd: p, mode: y }, g) => {
    const a = W({}), c = ve({ active: o }), x = we({}), C = Se({}), E = be({}), D = _e({}), I = je({}), _ = b(null), j = b(null);
    return N(() => {
      let u;
      return o && (j.current = document.activeElement, u = requestAnimationFrame(() => {
        var h;
        (h = _.current) == null || h.focus();
      })), () => {
        var h;
        u && cancelAnimationFrame(u), o || (h = j.current) == null || h.focus();
      };
    }, [o]), N(() => {
      var u;
      return o && ((u = document.getElementById("__next")) == null || u.setAttribute("aria-hidden", "true")), () => {
        var h;
        (h = document.getElementById("__next")) == null || h.removeAttribute("aria-hidden");
      };
    }, [o]), /* @__PURE__ */ e.jsx(F, { id: l, mode: y, show: o, zIndex: f, children: /* @__PURE__ */ e.jsx(
      "div",
      {
        className: r(a),
        onClick: (u) => {
          u.stopPropagation();
        },
        ref: g,
        children: /* @__PURE__ */ e.jsxs("div", { className: r(c), onAnimationEnd: p, children: [
          /* @__PURE__ */ e.jsx("div", { className: r(x), children: /* @__PURE__ */ e.jsx("span", { className: r(C), style: { overflowWrap: "anywhere" }, children: s }) }),
          !!i && /* @__PURE__ */ e.jsx("div", { className: r(E), children: /* @__PURE__ */ e.jsx("span", { className: r(D), children: i }) }),
          /* @__PURE__ */ e.jsxs("div", { className: r(I), children: [
            !!t && /* @__PURE__ */ e.jsx(
              O,
              {
                fullWidth: !0,
                onClick: t.onClick,
                size: "medium",
                theme: "outlined_basic",
                title: t.text,
                weight: "bold",
                children: t.text
              }
            ),
            /* @__PURE__ */ e.jsx(
              O,
              {
                fullWidth: !0,
                onClick: n.onClick,
                ref: _,
                size: "medium",
                theme: "outlined_secondary",
                title: n.text,
                weight: "bold",
                children: n.text
              }
            )
          ] })
        ] })
      }
    ) });
  }
);
Ne.displayName = "NDS.Dialog";
const Ee = d(
  ["inline-flex overflow-auto flex-col bg-static-white rounded-16 py-24"],
  {
    variants: {
      size: {
        medium: "w-[40rem]",
        large: "w-[60rem]"
      },
      active: {
        true: "animate-dialogScaleDown",
        false: "animate-dialogScaleUp"
      }
    }
  }
), De = d([
  "min-h-40 pl-32 pr-20 flex items-start justify-between gap-16 self-stretch"
]), Ie = d(["my-8 text-text-neutral-main select-none"], {
  variants: {
    titleType: {
      action: "typography-subtitle-18-bold truncate",
      highlight: "typography-subtitle-18-bold line-clamp-2",
      noPadding: ""
    }
  },
  defaultVariants: {
    titleType: "action"
  }
}), He = d(["flex items-center justify-center size-40 p-4 cursor-pointer"]), Re = d("overflow-auto relative h-full", {
  variants: {
    bodyType: {
      default: "px-32",
      noPadding: ""
    }
  }
}), Te = d("w-full shrink-0", {
  variants: {
    footerType: {
      default: "px-32 pt-12",
      noPadding: ""
    }
  }
}), ke = 48, ze = A((l, o) => {
  var L, M;
  const {
    id: s,
    show: i,
    title: n,
    titleType: t = "action",
    body: f,
    bodyType: p = "default",
    footer: y,
    footerType: g = "default",
    height: a = "contents",
    noCloseIcon: c = !1,
    className: x,
    onAnimationEnd: C,
    onClose: E,
    mode: D,
    zIndex: I,
    bottomSheetBodyRef: _,
    size: j = "medium",
    onScroll: u,
    hasBottomGradation: h = !0,
    onBackdropClick: q
  } = l, v = b(null), H = b(null), R = b(null), [U, X] = S(!1), [V, Y] = S(!1), [J, K] = S(0), [Q, Z] = S(0), ee = z(() => s ?? Date.now().toString(), [s]), te = W(), ne = Ee({
    active: i,
    size: j
  }), oe = De(), ie = He(), ae = Ie({ titleType: t }), le = Re({ bodyType: p }), re = Te({ footerType: g }), se = z(() => a === "contents" ? "auto" : a === "full" ? "100%" : a, [a]), T = fe(() => {
    if (v.current) {
      const { scrollTop: m, scrollHeight: w, clientHeight: k } = v.current, de = m + k >= w;
      Y(!de);
    }
  }, 100), ce = (m) => {
    T(), u == null || u(m);
  };
  return N(() => {
    const m = () => {
      if (v.current) {
        const { scrollHeight: w, clientHeight: k } = v.current;
        X(w > k);
      }
    };
    if (i)
      return T(), m(), window.addEventListener("resize", m), () => {
        window.removeEventListener("resize", m);
      };
  }, [i, v.current, a]), N(() => {
    var m, w;
    i && (T(), Z(((m = R.current) == null ? void 0 : m.clientHeight) ?? 0), K(((w = H.current) == null ? void 0 : w.clientHeight) ?? 0));
  }, [i, (L = R.current) == null ? void 0 : L.clientHeight, (M = H.current) == null ? void 0 : M.clientHeight]), /* @__PURE__ */ e.jsx(F, { id: ee, mode: D, onBackdropClick: q, show: i, zIndex: I, children: /* @__PURE__ */ e.jsx(
    "div",
    {
      className: r(te, "flex"),
      onClick: (m) => {
        m.stopPropagation();
      },
      ref: o,
      style: {
        maxHeight: "calc(100vh - 200px)",
        height: se,
        minHeight: `${Q + J + ke}px`
      },
      children: /* @__PURE__ */ e.jsxs("div", { className: r(ne, x), onAnimationEnd: C, children: [
        /* @__PURE__ */ e.jsx("div", { ref: R, children: t === "noPadding" ? n : /* @__PURE__ */ e.jsxs("div", { className: r(oe), children: [
          /* @__PURE__ */ e.jsx("span", { className: r(ae), children: n }),
          !c && /* @__PURE__ */ e.jsx(
            ye,
            {
              className: r(ie),
              icon: /* @__PURE__ */ e.jsx(me, { className: "size-24" }),
              onClick: E,
              size: "medium",
              theme: "ghost"
            }
          )
        ] }) }),
        !!f && /* @__PURE__ */ e.jsxs("div", { className: "relative h-full overflow-y-auto", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: r(le),
              onScroll: ce,
              ref: pe([v, _]),
              children: f
            }
          ),
          U && h ? /* @__PURE__ */ e.jsx(
            "div",
            {
              className: r(
                "pointer-events-none absolute inset-x-0 bottom-0 z-50 h-80 px-32 opacity-0 transition-opacity duration-500",
                {
                  "opacity-100": V
                }
              ),
              style: {
                background: "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 82.36%)"
              }
            }
          ) : null
        ] }),
        !!y && /* @__PURE__ */ e.jsx("div", { className: r(re), ref: H, children: y })
      ] })
    }
  ) });
});
ze.displayName = "NDS.PcDialogSheet";
export {
  G as D,
  ze as P,
  Ne as a,
  xe as u
};
